import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IAuthSignUpApplicantVerifyDto,
  IAuthSignUpApplicantVerifyResponse,
} from "./types";

const postApis = createPostApi<
  IApiResponse<IAuthSignUpApplicantVerifyResponse>,
  IPathBaseParam,
  IAuthSignUpApplicantVerifyDto
>("auth.signUpApplicant.signUpApplicantVerify");

export const signUpApplicantVerify = {
  ...postApis,
};
